/**
 * 微信小程序导流记录信息
 */
import React from 'react';

import { Row, Col, DatePicker, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';
import DictSelect from '../../ui/DictSelect';

class DiversionIndex extends React.Component {

    columns = [{
        title: '用户名',
        dataIndex: 'username',
        width: '10%',
    }, {
        title: '微信标识',
        dataIndex: 'openId',
        width: '10%',
    }, {
        title: '来源服务',
        dataIndex: 'appType',
        width: '10%',
    }, {
        title: '目标服务',
        dataIndex: 'target',
        width: '10%',
    }, {
        title: '车辆id',
        dataIndex: 'vehicleId',
        width: '10%',
    }, {
        title: '导流时间',
        dataIndex: 'insertTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }


    dictSelect = (filed, val) => {
         let queryData = this.state.queryData;
         queryData[filed] = val;
         this.setState({ queryData: queryData });
         this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNo = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/mallLog/diversion/download',
            data: queryData,
            fileName: "客户导流记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} />
                                <DictSelect category="coagency" style={{ width: 180, marginLeft: '10px', marginRight: '10px' }} 
                                    allowClear={true} onChange={this.dictSelect.bind(this, "target")} />
                                <DictSelect category="APP_TYPE" style={{ width: 180 }} allowClear={true} onChange={this.dictSelect.bind(this, "appType")} />
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/mallLog/diversion/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default DiversionIndex;